import React, { useState } from 'react';
import OfferCard from './OfferCard'; 
import './offers.css'

const Offers = ({ title, data }) => {
  const initialDisplayCount = 3;
  const [displayCount, setDisplayCount] = useState(initialDisplayCount);
  const [isExpanded, setIsExpanded] = useState(false); 

  const toggleDisplay = () => {
    if (isExpanded) {
      setDisplayCount(initialDisplayCount);
    } else {
      setDisplayCount(data.length);
    }
    setIsExpanded(!isExpanded);
  };

  const displayedOffers = data.slice(0, displayCount);

  return (
    <div className="offers__container">
      <h1>OFERTAS</h1>
      <div className="offers-cards__container">
        <div className="offers-cards__item-container">
          {displayedOffers.map((offer) => (
            <OfferCard key={offer.id} offer={offer} />
          ))}
        </div>
        <div>
          {data.length > initialDisplayCount && ( 
            <button onClick={toggleDisplay} id="offers_more-button">
              {isExpanded ? 'Ver menos' : 'Ver más'}
            </button>
          )}
        </div>
      </div>  
    </div>
  );
};

export default Offers;



